export const types = {
  SET_COOKIE_MANAGEMENT_TYPE: 'SET_COOKIE_MANAGEMENT_TYPE',
  UPDATE_COOKIE_MANAGEMENT_TYPE: 'UPDATE_COOKIE_MANAGEMENT_TYPE',
  SET_SHOW_COOKIE_MANAGEMENT_ON_COOKIE_DECLARATION_PAGE:
    'SET_SHOW_COOKIE_MANAGEMENT_ON_COOKIE_DECLARATION_PAGE',
  SET_CUSTOMIZE_COOKIE: 'SET_CUSTOMIZE_COOKIE'
};
